function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.06 18.235H8.074c-.181 0-.362.042-.53.12l-5.133 2.51V5.974h3.88V3.563H2.415A2.423 2.423 0 0 0 0 5.974v16.819c0 .416.217.802.566 1.025.193.12.416.181.639.181.18 0 .361-.042.53-.12l6.62-3.233h9.706a2.418 2.418 0 0 0 2.41-2.412V16.34h-2.41v1.894z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m21.048 10.535-.572-.572-.428-.429c.163-.229.301-.47.428-.717.277-.537.47-1.122.572-1.731.054-.332.09-.67.09-1.02 0-.349-.036-.687-.09-1.018a5.979 5.979 0 0 0-.554-1.689C19.494 1.363 17.45 0 15.084 0c-2.368 0-4.41 1.369-5.404 3.353a5.985 5.985 0 0 0-.639 2.63v.078c0 3.34 2.717 6.06 6.055 6.06a5.992 5.992 0 0 0 3.205-.928l2.18 2.183.573.573 1.241 1.242L24 13.484l-2.946-2.949h-.006zm-9.603-4.474v-.079a3.608 3.608 0 0 1 1.211-2.629 3.627 3.627 0 0 1 2.428-.94c.934 0 1.783.355 2.428.94a3.628 3.628 0 0 1 1.217 2.708c0 .778-.247 1.501-.67 2.098a3.645 3.645 0 0 1-2.975 1.55 3.651 3.651 0 0 1-3.645-3.648h.006z"
});

var SvgTrackTicket = function SvgTrackTicket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrackTicket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/track-ticket.e8da28c9.svg";
export { ForwardRef as ReactComponent };